import React, { Component } from "react";
import Home from "../Home/Home";
import Aux from "../../../hoc/Auxilliary";
import Header from "../Common/Header/Header";
import Workflow from "../Workflow/Workflow";
import LearningCategories from "../Learning/LearningCategories/LearningCategories";
import LearningVideos from "../Learning/LearningVideos/LearningVideos";
import Assignment from "../Learning/Assignment/Assignment";
import AssignmentResult from "../Learning/Assignment/Result/Result";
import ErrorModal from "../Common/ErrorModal/ErrorModal";

class Main extends Component {
  state = {
    show: false,
    error: "",
    errorTitle: ""
  };
  handleClose() {
    this.setState({ show: false });
  }
  showError(error) {
    // console.log("inside show error");
    if (error.request.response === "") {
      // console.log(error.request);
      this.setState({
        show: true,
        errorTitle: "Network Error",
        error:
          "Looks like network error! Request was made but no response received. Please try after sometime or contact administrator"
      });
    } else if (error.response) {
      // console.log(error.response);
      if (error.response.status === 500) {
        let errormessage = (
          <div>
            <div>
              <strong>Exception Message: </strong>
              {error.response.data.ExceptionMessage}
            </div>
            <div>
              <strong>Exception Type: </strong>
              {error.response.data.ExceptionType}
            </div>
            <div>
              <strong>Message: </strong>
              {error.response.data.Message}
            </div>
            <div>
              <strong>StackTrace: </strong>
              {error.response.data.StackTrace}
            </div>
          </div>
        );

        this.setState({
          show: true,
          error: errormessage,
          errorTitle: error.response.statusText
        });
      } else if (error.response.status === 400) {
        let errormessage = "";
        errormessage += error.response.data.Message;
        errormessage += error.response.data.ModelState[""].join(",");
        this.setState({
          show: true,
          error: errormessage,
          errorTitle: error.response.statusText
        });
      } else if (error.response.status === 401) {
        let errormessage = "";
        errormessage += error.response.data.Message;
        this.setState({
          show: true,
          error: errormessage,
          errorTitle: error.response.statusText
        });
      }
    } else {
      this.setState({
        show: true,
        error:
          "Oops! We are sorry. There seems to be an error. Kindly login again. If the error persists, contact administrator"
      });
    }
  }
  render() {
    let pageComponent = null;
    const page = this.props.page;
    if (page === "home" || page === "") {
      pageComponent = (
        <Home {...this.props} showError={error => this.showError(error)} />
      );
    } else if (page === "workflow") {
      pageComponent = (
        <Workflow {...this.props} showError={error => this.showError(error)} />
      );
    } else if (page === "learningcategories") {
      pageComponent = (
        <LearningCategories
          {...this.props}
          showError={error => this.showError(error)}
        />
      );
    } else if (page === "learningvideos") {
      pageComponent = (
        <LearningVideos
          {...this.props}
          showError={error => this.showError(error)}
        />
      );
    } else if (page === "assignment") {
      pageComponent = <Assignment {...this.props} />;
    } else if (page === "assignmentresult") {
      pageComponent = <AssignmentResult {...this.props} />;
    }
    return (
      <Aux>
        <div className="top_band">
          <Header key="header1" {...this.props} />
        </div>
        {pageComponent}
        <ErrorModal
          show={this.state.show}
          onHide={() => this.handleClose()}
          title={this.state.errorTitle}
          error={this.state.error}
        />
      </Aux>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/containers/User/Main/Main.js